import React, { useContext } from 'react';
import { ColumnProps } from 'antd/lib/table';

import InternalUserOrgsTable from '@totem/components/orgManagement/orgDetails/users/options/InternalUserOrgsTable';
import InternalUsersContext from '@totem/components/orgManagement/orgDetails/users/options/internalUsersContext';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import { User } from '@totem/components/users/container/types';
import { isNotNull } from '@totem/utilities/common';
import { DateStringToLocalDate } from '@totem/utilities/dateUtilities';
import { sortStringAscending } from '@totem/utilities/tableUtilities';

const InternalUsersTable = () => {
  const { internalUsers, pageSize } = useContext(InternalUsersContext);

  const columns: ColumnProps<User>[] = [
    {
      title: 'Username',
      dataIndex: 'email',
      key: 'email',
      render: (_, record: User) => <span>{record.email}</span>,
      defaultSortOrder: 'ascend',
      sorter: (compA, compB) => sortStringAscending(compA.email, compB.email),
    },
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      render: (_, record: User) => <span>{record.firstName}</span>,
      defaultSortOrder: 'ascend',
      sorter: (compA, compB) =>
        sortStringAscending(compA.firstName, compB.firstName),
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      render: (_, record: User) => <span>{record.lastName}</span>,
      defaultSortOrder: 'ascend',
      sorter: (compA, compB) =>
        sortStringAscending(compA.lastName, compB.lastName),
    },
    {
      title: 'Last Login',
      dataIndex: 'lastLoginDate',
      key: 'lastLoginDate',
      render: (_, record: User) => (
        <span>{DateStringToLocalDate(record.lastLoginDate)}</span>
      ),
      defaultSortOrder: 'ascend',
      sorter: (compA, compB) =>
        sortStringAscending(compA.lastLoginDate, compB.lastLoginDate),
    },
  ];

  return (
    <>
      <IBTable
        showSorterTooltip
        columns={columns}
        dataSource={isNotNull(internalUsers) ? internalUsers : []}
        loading={false}
        rowKey={(record) => record.id}
        pagination={{
          showSizeChanger: true,
          pageSize,
        }}
        expandable={{
          expandedRowRender: (record) => (
            <InternalUserOrgsTable user={record} />
          ),
          defaultExpandAllRows: false,
        }}
      />
    </>
  );
};

export default InternalUsersTable;
